/**
 * TRL Player Item Component
 *
 * Trailblazers-specific row for displaying a player in a round.
 * Simple: just the display name (captures are scored at the team level).
 */

import { memo } from 'react';
import { RoundPlayer, Player, getPlayerDisplayName } from '@swtorbit/shared-socket-events';

interface TrlPlayerItemProps {
  player: RoundPlayer;
  gamePlayers: Player[];
}

export const TrlPlayerItem = memo(function TrlPlayerItem({ player, gamePlayers }: TrlPlayerItemProps) {
  return (
    <div className="d-flex align-items-center gap-2xs">
      <span className="text-white fs-sm">{getPlayerDisplayName(player.playerId, gamePlayers)}</span>
    </div>
  );
});
